export {default} from "./secondSlide";
